// Geocoordinates of city BadTölz.
export const BAD_TOELZ_CENTER = {
    lat: 47.7614737,
    lng: 11.5651524
};

export const BAD_TOELZ_INITIAL_ZOOM = 14;

export const BAD_TOELZ_INTERSECTION_COORDINATES = [
	{lat: 47.731571498830874, lng: 11.508884033374557},
	{lat: 47.78200319797642, lng: 11.608962616138228}
];

export const PLACE_DETAILS_FIELDS = [
	'business_status',
	'formatted_phone_number',
	'geometry',
	'icon',
	'name',
	'opening_hours',
	'photos',
	'place_id',
	'types',
	'url',
	'utc_offset_minutes', // required for 'opening_hours.isOpen()'
	'vicinity',
	'website',
];

export const MAX_PLACES_PER_PAGE = 20;
